//#region [IMPORT]

// === THIRD-PARTY ===
import React from 'react';

import { styled, keyframes } from '@mui/system';

//#endregion

//-----------------------------------------------------------------
export function BorderCorners( {children, width='200px', height='100px', thickness='3px', length='20px', color='black', animate=true, is_open=true, topLeft=true, topRight=true, bottomLeft=true, bottomRight=true } ) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const expand = keyframes`
    from {
      width   : 2rem;
      height  : 2rem;
      padding : 0;
    }
    to {
      width   : calc( ${width  + 10}px + ${thickness} );
      height  : calc( ${height + 12}px + ${thickness} );
      padding-left   : 4px;
      padding-top    : 4px;
      padding-right  : 0px;
      padding-bottom : 0px;
  `;
  const shrink = keyframes`
    from {
      width   : calc( ${width  + 10}px + ${thickness} );
      height  : calc( ${height + 12}px + ${thickness} );
      padding-left   : 4px;
      padding-top    : 4px;
      padding-right  : 0px;
      padding-bottom : 0px;
    }
    to {
      width   : 2rem;
      height  : 2rem;
      padding : 0;
    }
  `;

  const color_stop = `#0000 90deg,${color} 0`;
  const p = `${length} ${length} border-box no-repeat`;

  // Required to add animation keyframe for use by non React elements
  const AnimationExpand = styled('div')({
    display: 'none',

    // === Animation
    animation: `${expand}`,
  })
  const AnimationShrink = styled('div')({
    display: 'none',

    // === Animation
    animation: `${shrink}`,
  })

  //#endregion

  //#region [STYLES]
  const _styles = {
    border: {
      
      overflow: 'hidden',

      // === Border
      // ------------------------------------------------------------------------
      border       : `${thickness} solid #0000`, /* space for the border */
      borderRadius : '0.5rem',
      background   : [
        topLeft     ? `conic-gradient( from 90deg  at top    ${thickness} left  ${thickness}, ${color_stop} ) 0    0    / ${p}` : 0,
        topRight    ? `conic-gradient( from 180deg at top    ${thickness} right ${thickness}, ${color_stop} ) 100% 0    / ${p}` : 0,
        bottomLeft  ? `conic-gradient( from 0deg   at bottom ${thickness} left  ${thickness}, ${color_stop} ) 0    100% / ${p}` : 0,
        bottomRight ? `conic-gradient( from -90deg at bottom ${thickness} right ${thickness}, ${color_stop} ) 100% 100% / ${p}` : 0
      ],

      // === Animation
      // -------------------------------------------------------------------------
      animationName     : is_open ? `${expand.name}` : `${shrink.name}`,
      animationDuration : animate ? '0.5s' : '0s',
      animationFillMode : 'forwards',
    },
  }

  const BORDER = {
    style: _styles.border,
  };
    
  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <div { ...BORDER }>
        <AnimationExpand />
        <AnimationShrink />
        {children}
      </div>
    )
  }

  //#endregion

  return display();
}
